<template>
  <div>
    <!--操作栏-->
    <div>提示：聚商专用页面！</div>
    <div class="action-bar">
      <el-input
        placeholder="商人ID"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.uid"
        class="param-input"
        @keyup.enter.native="getGatheringList('status')"
      ></el-input>
      <el-input
        placeholder="账户名"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.name"
        class="param-input"
        @keyup.enter.native="getGatheringList('status')"
      ></el-input>
      <el-input
        placeholder="昵称"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.nickname"
        class="param-input"
        @keyup.enter.native="getGatheringList('status')"
      ></el-input>
      <el-input
        placeholder="手机号"
        clearable
        size="small"
        @clear="handleClear"
        v-model="form.mobile"
        class="param-input"
        @keyup.enter.native="getGatheringList('status')"
      ></el-input>
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-circle-plus"
        @click="billAction('add')"
      >新增商人</el-button>
      <el-button
        type="primary"
        size="mini"
        @click="getGatheringList('status')"
        style="marginRight: 15px"
      >搜索</el-button>当前余额:
      <span style="color: red">{{currentBalance}}</span>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        prop="uid"
        label="商人ID"
        fixed
        align="center"
        :show-overflow-tooltip="true"
        min-width="110"
      >
        <template slot-scope="scope">
          <span>{{scope.row.uid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="账号" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="商人账户余额(元)" align="center" min-width="130">
        <template slot-scope="scope">
          <span>{{scope.row.balance | transformFloat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="hasLocked" label="已禁止登陆" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.hasLocked ?'是':"否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lockReason" label="禁止登陆的原因" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.lockReason || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isDeleted" label="是否已经删除" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.isDeleted ?'是':"否" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="300">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="billAction('edit',scope.row)"
          ></el-button>
          <el-button
            type="warning"
            size="mini"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          ></el-button>
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="addOrDebitScore(scope.row)"
          >上分</el-button>
          <el-button type="success" size="mini" icon="el-icon-edit" @click="seekScore(scope.row)">追分</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="form.pageNumber"
      :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 子组件 -->
    <bill-action ref="billAction" @handlerBillList="handlerBillList"></bill-action>
    <addOrDebitScore ref="addOrDebitScore" @handlerBillList="handlerBillList"></addOrDebitScore>
    <seekScore ref="seekScore" @handlerBillList="handlerBillList"></seekScore>
  </div>
</template>
<script>
import API from "@/api";
import BillAction from "./components/billAction";
import AddOrDebitScore from "./components/addOrDebitScore";
import SeekScore from "./components/seekScore";
export default {
  components: {
    BillAction,
    AddOrDebitScore,
    SeekScore,
  },
  data() {
    return {
      // 列表数据
      tableData: [],
      total: "",
      time: "",
      // 当前余额
      currentBalance: "",
      // 请求列表数据参数
      form: {
        pageNumber: 1,
        pageSize: 10,
        uid: undefined,
        name: undefined,
        nickname: undefined,
        mobile: undefined,
        cid: undefined,
      },
    };
  },
  created() {
    this.getGatheringList();
    this.businessblBalance();
  },
  methods: {
    // 商人当前余额列表
    businessblBalance() {
      API.businessblBalance()
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.currentBalance = res.data.Balance + "元";
            // this.tableData = res.data.list
            // this.total = res.data.total
          } else {
            this.currentBalance = "未知";
            // this.tableData = []
            // this.total = 0
          }
          // this.loading = false
        })
        .catch(() => {
          this.currentBalance = "未知";
          // this.loading = false
        });
    },
    handleClear(type) {
      this.form[type] = undefined;
      this.getGatheringList("status");
    },
    // 请求聚商列表参数
    getGatheringList(type) {
      if (type === "status") {
        this.pageNumber = 1;
      }
      API.getGatheringList(this.form)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          // this.loading = false
        })
        .catch(() => {
          // this.loading = false
        });
    },

    handlerBankList() {
      this.getGatheringList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.form.pageSize = size;
      this.form.pageNumber = 1;
      this.getGatheringList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.form.pageNumber = pageNumber;
      this.getGatheringList();
    },
    billAction(type, data) {
      this.$refs.billAction.open(type, data);
    },
    addOrDebitScore(data) {
      this.$refs.addOrDebitScore.open(data);
    },
    seekScore(data) {
      this.$refs.seekScore.open(data);
    },
    handlerBillList() {
      this.getGatheringList();
    },
    // 删除聚商
    handleDelete(row) {
      this.$confirm("确定删除？")
        .then(() => {
          API.delGatheringList({ uids: [row.uid] }).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.getGatheringList();
            } else {
              this.$message.error(res.tip);
            }
          });
        })
        .catch(() => {
          this.$message("取消删除");
        });
    },
  },
};
</script>

